<span>
  Měsíční data KN aktuální k {{cadastreDataDate| date: 'd. M. yyyy'}}
</span>
